<template>
	<div>
		<b-row>
			<b-col cols="12" lg="4" class="number">
				<h6>Net sales</h6>

				<span class="spinning-number" :class="visible ? 'visible-transition' : 'invisible-transition'">
					<i-count-up :start="0"
								      :end="firstEndVal"
								      :decimals="0"
								      :duration="1.5"
								      :options="options"
											:callback="countUp">
					</i-count-up>
		    </span>
				<span class="number-info">MEUR</span>
			</b-col>

			<b-col cols="12" lg="4" class="number">
				<h6>EBITDA margin (comparable)</h6>

				<span class="spinning-number"
							:class="visible ? 'visible-transition' : 'invisible-transition'">
					<i-count-up :start="0"
								      :end="secondEndVal"
								      :decimals="1"
								      :duration="2"
								      :options="options"
											:callback="countUp">
					</i-count-up>%
				</span>
			</b-col>

			<b-col cols="12" lg="4" class="number">
				<h6>Proposed dividend</h6>
				<span class="spinning-number"
							:class="visible ? 'visible-transition' : 'invisible-transition'">
					<i-count-up :start="0"
								      :end="thirdEndVal"
								      :decimals="2"
								      :duration="2"
								      :options="options"
											:callback="countUp">
					</i-count-up>
				</span>
				<div class="number-info-continer">
					<span class="number-info">EUR</span>
					<span class="small number-info">per share</span>
				</div>

			</b-col>
		</b-row>
	</div>
</template>

<script>
	import ICountUp from 'vue-countup-v2';

	export default {
		props: {
	    visible: {
        default: () => false
	    }
		},
		components: {
      ICountUp
    },
    data() {
      return {
	      firstEndVal: 0,
	      secondEndVal: 0,
	      thirdEndVal: 0,
        options: {
          useEasing: 		true,
          useGrouping: 	true,
          separator: 		',',
          decimal: 			'.',
          prefix: 			'',
          suffix: 			''
        }
      };
    },
    methods: {
	    countUp: function(ins) {}
    },
    watch: {
		  visible: function(val) {
			  if(val) {
				  this.firstEndVal 	= 2233;
					this.secondEndVal = 13.0;
					this.thirdEndVal 	= 0.52;
			  }else{
				  this.firstEndVal 	= 0;
					this.secondEndVal = 0;
					this.thirdEndVal 	= 0;
			  }
		  }
	  }
	}
</script>



// WEBPACK FOOTER //
// src/components/Numbers.vue